export default [
  {
    path: '/investments/secondary-market',
    name: 'secondary-market',
    component: () => import(/* webpackChunkName: 'PageSecondaryMarket' */ '../PageSecondaryMarket'),
    meta: {
      requiresAuth: true,
      store: [
        'account/loadAccountListOnce',
      ],
    },
  },
];
